"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _usageTracker = _interopRequireDefault(require("./usageTracker"));

var _ = require("_");

var getTracker = (0, _.memoize)(function (settingId, interaction) {
  return (0, _.debounce)(function () {
    _usageTracker.default.track('sulSettingsEdit', {
      settingId: settingId,
      interaction: interaction
    });
  }, 400);
}, function (settingId, interaction) {
  return settingId + " " + interaction;
});

var _default = function _default(settingId, interaction) {
  getTracker(settingId, interaction)();
};

exports.default = _default;
module.exports = exports.default;